import React from 'react';

interface StopImpersonationDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const StopImpersonationDialog: React.FC<StopImpersonationDialogProps> = ({
  isOpen,
  onClose,
  onConfirm
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
      <div className="bg-white rounded-lg p-6 max-w-sm w-full mx-4">
        <div className="flex justify-between items-center mb-4 pb-4 border-b border-gray-200">
          <h2 className="text-lg font-semibold">Impersonate Sign Out</h2>
          <button 
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700 text-2xl w-8 h-8 flex items-center justify-center"
          >
            ×
          </button>
        </div>
        
        <p className="text-gray-600 mb-6 border-b border-gray-200  pb-4">Do you want to exit?</p>
        
        <div className="flex justify-end gap-4 ">
          <button
            onClick={onClose}
            className="px-4 py-2 text-white bg-gray-500 rounded-md hover:bg-gray-600 focus:outline-none"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600"
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
};

export default StopImpersonationDialog;